import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { ApplicationService } from 'src/app/Core/services/application.service';
import { LanguageService } from 'src/app/Core/services/language.service';
import { SessionService } from 'src/app/Core/services/session.service';
export interface IMerchant {
  id: string;
  name: string;
  imageUrl: string;
}

@Component({
  selector: 'app-grid-search',
  templateUrl: './grid-search.component.html',
  styleUrls: ['./grid-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridSearchComponent {
  @ViewChild('Merchants')
  Merchants: ElementRef | undefined;
  @Input() name: string = '';
  @Input() label: string = '';
  @Input() text: string = 'text';
  @Input() logo: string = 'logo';
  @Input() set data(data: any) {
    this._data = data;
    this.loading = false;
    this.loadMoreLoading = false;
  }
  @Input() onlineSearch: boolean = false;
  @Input() scrollListner: boolean = false;
  @Input() currentValue: any;
  @Output() currentValueChange = new EventEmitter<any>();
  @Output() loadMore = new EventEmitter<void>();
  @Output() keyWord = new EventEmitter<string>();
  mode = 'grid';
  searchTerm = '';
  timer: any;
  loading = true;
  _data: any[] = [];
  loadMoreLoading = false;
 public select(merchant: any) {
  
    this.currentValueChange.emit(merchant);
  }
  constructor(
    public application: ApplicationService,
    public session:SessionService,
    private languageService: LanguageService
  ) {}
  ngAfterViewInit() {
    this.addScrollEvent();
    //this.loadMore.emit();
  }

  private addScrollEvent() {
    let el = this.Merchants?.nativeElement;
    el.addEventListener('scroll', () => {
      let bottom =
        Math.abs(el.scrollHeight - el.scrollTop - el.clientHeight) < 1;
      if (bottom && this.scrollListner && !this.loadMoreLoading) {
        this.loadMoreLoading = true;
        this.loadMore.emit();
      }
    });
  }

  startOnlineSearch() {
    this.loading = false;
    if (!this.onlineSearch) return;
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.loading = true;
      this.keyWord.emit(this.searchTerm);
    }, 1000);
  }

  get isLeft() {
    return this.languageService.CurrentLang.IsLeft;
  }
}
